export default __webpack_public_path__ + "static/media/bin.601690aa.svg";